'use client';

import { Dispatch, SetStateAction } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@radix-ui/react-dropdown-menu';
import { HoverableIcon } from './HoverableIcon';
import { Library } from '@/icons';
import { PromptExamples } from '@/types/terminal';

export const SupportedActionsDropDown = ({
  actions,
  activeButton,
  setActiveButton,
  setPrompt,
}: {
  actions: PromptExamples;
  activeButton: string | null;
  setActiveButton: Dispatch<SetStateAction<string | null>>;
  setPrompt: (value: SetStateAction<string>) => void;
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <HoverableIcon
          icon={Library}
          label="Supported actions"
          isActive={activeButton === 'actions'}
          onMouseEnter={() => setActiveButton('actions')}
          onMouseLeave={() => setActiveButton(null)}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-grey-800 rounded p-4" side="top" align="start">
        {actions.map((action) => (
          <DropdownMenuItem
            key={action.label}
            className="cursor-pointer font-sans hover:bg-grey-400 outline-none p-[2px] rounded text-grey-150 transition-colors"
            onClick={() => setPrompt(action.value)}
          >
            {action.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
